// src/components/common/SearchButton.tsx
import React from 'react';
import './SearchButton.css';
import { logger } from '@/utils/logger';

interface SearchButtonProps {
  isLoading: boolean;
  onClick: () => void;
  children: React.ReactNode;
  disabled?: boolean;
  className?: string;
}

const SearchButton: React.FC<SearchButtonProps> = ({
  isLoading,
  onClick,
  children,
  disabled = false,
  className = '',
}) => {
  logger.log("SearchButton renderizado, isLoading:", isLoading);

  return !isLoading ? (
    <button
      type="button"
      onClick={onClick}
      className={`search-button ${className}`}
      disabled={disabled}
    >
      {children}
    </button>
  ) : (
    <button type="button" className={`search-button loading ${className}`} disabled>
      <div className="spinner"></div>
    </button>
  );
};

export default SearchButton;